import ButtonCommon from 'components/common/ButtonCommon';
import { REFERRAL_CONTENT_TABS_LABEL } from 'constants';
import useLang from 'hooks/useLang';
import { useState } from 'react';
import styled from 'styled-components';
import ReferralContentTab1 from '../ReferralContentTab1';
import ReferralContentTab2 from '../ReferralContentTab2';
import ReferralContentTab3 from '../ReferralContentTab3';

const ReferralContent = () => {
  const { t } = useLang();

  const [current, setCurrent] = useState(0);

  const handleOnClick = (index) => {
    setCurrent(index);
  };

  const referralContentReference = {
    0: <ReferralContentTab1 />,
    1: <ReferralContentTab2 />,
  };

  return (
    <ReferralContentStyled>
      <TabWrap>
        {REFERRAL_CONTENT_TABS_LABEL.map((tab, index) => {
          const isActive = current === index;
          return (
            <ButtonCommon
              key={tab.label}
              value={t(tab.label)}
              background={isActive ? 'var(--c-tab-active-2)' : 'transparent'}
              color={isActive ? 'var(--ds-c-blue)' : 'var(--ds-c-black)'}
              styles={{
                fontSize: '14px',
                lineHeight: '18px',
                width: `${100 / REFERRAL_CONTENT_TABS_LABEL.length}%`,
                borderRadius: '0px',
                height: '30px',
                float: 'left',
                fontWeight: 500,
                textTransform: 'uppercase',
                borderBottom: 'none',
                ...(isActive && {
                  boxShadow: '0px 1px 6px 0px #0000001A',
                  borderBottom: 'none',
                  borderRadius: '100px',
                }),
                paddingInline: 0,
              }}
              onClick={() => handleOnClick(index)}
            />
          );
        })}
      </TabWrap>
      <ContentBody>{referralContentReference[current]}</ContentBody>
      <ReferralContentTab3 />
    </ReferralContentStyled>
  );
};

const ReferralContentStyled = styled.div`
  position: relative;
`;

export const TabWrap = styled.div`
  height: 40px;
  width: 100%;
  background-color: #dce3f14d;
  padding: 5px;
  border-radius: 100px;
`;

const ContentBody = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-block: 20px;
`;

export default ReferralContent;
